module.exports = __webpack_public_path__ + "media/images/notice-1690a521b24dc0fc072b4931d78d65dd.svg";